// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3348":"9feacc00","7682":"a74531de"}[chunkId] + ".chunk.css";
};